import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RoleService} from '../../services/role.service';
import {MatTableGeneratorComponent} from '../../shared/mat-table-generator/mat-table-generator.component';
import {MultiCrudDataSource} from '../../table-datasouces/multi-crud.datasource';
import {CardsService} from '../services/cards.service';
import {Card} from '../../dto/card';
import {toDateString, toDateTimeString} from '../../providers/app-date-adapter';
import {AppMatCustomAction} from '../../shared/mat-table-generator/mat-table-core/app-mat-custom-action';
import {FileHelper} from '../../helpers/file-helper';
import {ConfirmDialogComponent} from '../../shared/confirm-dialog/confirm-dialog.component';
import {OrdersService} from '../services/orders.service';
import {CardReorderDialogComponent} from '../../shared/card-reorder-dialog/card-reorder-dialog.component';
import {CardExtensionModel, CardReorderModel} from '../../models/card-reorder-model';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {CardUsageStatus} from '../../dto/ident-status';
import {CardStatus} from '../../dto/cardStatus';
import {CardExtensionDialogComponent} from '../../shared/card-extension-dialog/card-extension-dialog.component';
import {Toast} from 'angular-toastify/lib/toast';
import {ToastService} from 'angular-toastify';
import {Company} from '../../dto/company';
import {Product} from '../../dto/product';
import {CompanyService} from '../services/company.service';
import {ProductService} from '../services/product.service';
import {forkJoin} from 'rxjs';
import {CardStatusEnum} from '../../dto/card-status-enum';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.css']
})
export class CardsComponent implements OnInit {
  private refreshInterval: ReturnType<typeof setTimeout> | null;
  refreshPollCounter = 0;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private cardsService: CardsService,
    private ordersService: OrdersService,
    private snackBar: MatSnackBar,
    private changeDetectorRefs: ChangeDetectorRef,
    private dialog: MatDialog,
    private _toastService: ToastService,
    private companyService: CompanyService,
    private productService: ProductService,
  ) {
  }

  @ViewChild(MatTableGeneratorComponent, {static: true}) table: MatTableGeneratorComponent;
  cardsCustomActions: any[] = [];
  dataSource = new MultiCrudDataSource(this.cardsService);
  columns = [

    {columnDef: 'customer.firstName', header: 'First Name', cell: (row: Card) => `${row.customer.firstName}`},
    {columnDef: 'customer.lastName', header: 'Last Name', cell: (row: Card) => `${row.customer.lastName}`},
    {columnDef: 'customer.email', header: 'Email', cell: (row: Card) => `${row.customer.email}`},
    {columnDef: 'product.name', header: 'Product', cell: (row: Card) => `${row.product.name}`},
    {
      columnDef: 'token', header: 'Token', cell: (row: Card) => {
        let ret = '';

        if (row.isExtensionPending) {
ret += '📅 ';
} else {
          if (row.usageStatus == CardUsageStatus.dormant) {
ret += '💤 ';
}

          if (row.status == 0) // activated
            {
ret += '🟨 ';
} else if (row.status == 1) // activated
            {
ret += '🟩 ';
} else if (row.status == 6) // closed
            {
ret += '⬜️ ';
}
        }

        ret += row.token;
        if (row.primaryCardId) {
ret += ' ⛓';
}

        return ret;
      }
    },
    {
      columnDef: 'status', header: 'Status', cell: (row: Card) => {
        let ret = row.statusName;
        if (row.isExtensionPending) {
ret += ', Ext. Pending';
}
        return ret;
      }
    },
    {columnDef: 'creationDate', header: 'Creation Date', cell: (row: Card) => `${toDateTimeString(row.creationDate)}`},
    {columnDef: 'expireDate', header: 'Expiry Date', cell: (row: Card) => `${toDateString(row.expireDate)}`},
  ];

  public dateFiltersList = [
    {name: 'creationDate', header: 'Creation date'},
    {name: 'expireDate', header: 'Expiry date'}
  ];

  ngOnInit() {
    this.rebuildCustomActions();
    this.loadCompanies();
  }

  onSearch(isInvalid = false) {
    if (!isInvalid) {
      this.table.applyFilter();
    }
  }

  getViewLink = (item: Card): string => item.id.toString();

  getEditLink = (item: Card): string => item.id.toString() + '/edit';

  // editEnabled() {
  //   return this.roleService.hasRoles(["agent", "admin", "partner"]);
  // }

  // deleteEnabled() {
  //   return this.roleService.hasRoles("admin");
  // }

  // multiselectEnabled() {
  //   return this.roleService.hasRoles(["partner", "admin", "manager", "agent", "compliance"]);
  // }
  companies: Company[] = [];
  productsToShow: Product[] = [];
  cardStatus = CardStatusEnum;

  showMessage(message: string) {
    this._toastService.info(message);
    /*this.snackBar.open(message, null, {
      duration: 5000,
      panelClass: ["app-mat-snack-bar"]
    });*/
  }

  showError(message) {
    this._toastService.error(message);
    /*this.snackBar.open(message, null, {
      duration: 5000,
      panelClass: ["app-mat-snack-bar"]
    });*/
  }

  refreshPoll() {
    this.refreshDataSource();
    this.refreshPollCounter--;
    if (this.refreshPollCounter <= 0) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
      return;
    }

  }

  refreshDataSource() {
    this.dataSource.loadData();
    this.changeDetectorRefs.detectChanges();
    this.table.refreshTable();
  }

  currentUserIsAdmin(): boolean {
    return this.roleService.hasRoles('admin');
  }
  currentUserIsSuperAdmin(): boolean {
    return this.roleService.hasRoles( 'super_admin' );
  }

  currentUserIsCompliance(): boolean {
    return this.roleService.hasRoles('compliance');
  }

  currentUserIsPartner(): boolean {
    return this.roleService.hasRoles(['partner', 'partner_support']);
  }

  rebuildCustomActions() {
    if (this.currentUserIsAdmin() || this.currentUserIsCompliance() || this.currentUserIsPartner()) {
      this.cardsCustomActions = [
        new AppMatCustomAction('reply_all', 'Reorder selected cards', true, (rows: Card[]) => {
          this.dialog.open(CardReorderDialogComponent)
            .afterClosed()
            .subscribe(result => {
              if (result instanceof (CardReorderModel)) {
                const models = rows.map(elem => ({
                  id: elem.id,
                  reason: result.reason,
                  comment: result.comment
                } as CardReorderModel));
                this.ordersService.reorderCards(models)
                  .subscribe(() => {
                      this.refreshDataSource();
                      this.showMessage('Reordered successfully');
                    },
                    err => {
                      this.showMessage(err.error.message || err.error || err.message);
                    });
              }
            });
        }),

        new AppMatCustomAction('reply', 'Reorder card', false, (row: Card) => {
          this.dialog.open(CardReorderDialogComponent)
            .afterClosed()
            .subscribe(result => {
              if (result instanceof (CardReorderModel)) {
                result.id = row.id;
                this.ordersService.reorderCard(result)
                  .subscribe(() => {
                      this.refreshDataSource();
                      this.showMessage('Reordered successfully');
                    },
                    err => {
                      this.showMessage(err.error.message || err.error || err.message);
                    });
              }
            });
        }),

        new AppMatCustomAction('event', 'Extend card', false, (row: Card) => {
          this.dialog.open(CardExtensionDialogComponent, {
            data: {
              publicToken: row.token,
              text: `Are you sure you want to extend card ${row.token}?`,
              title: 'Extend card',
            }
          })
            .afterClosed()
            .subscribe(result => {
              if (result instanceof (CardExtensionModel)) {
                this.cardsService.extendCard(result.publicToken)
                  .subscribe(() => {
                    this.afterExtendCard();
                    },
                    err => {
                      this.showMessage(err.error.message || err.error || err.message);
                    });
              }
            });
        }, (data: Card) => data.isExtensionPending),

        new AppMatCustomAction('event', 'Extend selected cards', true, (rows: Card[]) => {
          this.dialog.open(ConfirmDialogComponent, {
            data: {
              title: 'Extend',
              text: 'Are you sure you want to extend these cards?'
            }
          })
            .afterClosed()
            .subscribe(result => {
              if (result == 'ok') {
                this.cardsService.extendCards(rows.map(row => row.id))
                  .subscribe(() => {
                      this.afterExtendCard();
                    },
                    err => {
                      this.showMessage(err.error.message || err.error || err.message);
                    });
              }
            });
        }),

        new AppMatCustomAction('cancel', 'Close selected cards', true, (rows: Card[]) => {
          this.dialog.open(ConfirmDialogComponent, {
            data: {
              title: 'Close',
              text: 'Are you sure you want to close these cards?'
            }
          })
            .afterClosed()
            .subscribe(result => {
              if (result == 'ok') {
                this.cardsService.closeCards(rows.map(row => row.id))
                  .subscribe(() => {
                      this.refreshDataSource();
                      this.showMessage('Cards closed successfully');
                    },
                    err => {
                      this.showMessage(err.error.message || err.error || err.message);
                    });
              }
            });
        }),

        new AppMatCustomAction('cancel', 'Close card', false, (row: Card) => {
          this.dialog.open(ConfirmDialogComponent, {
            data: {
              title: 'Close',
              text: 'Are you sure you want to close this card?'
            }
          })
            .afterClosed()
            .subscribe(result => {
              if (result == 'ok') {
                this.cardsService.closeCards([row.id])
                  .subscribe(() => {
                      this.refreshDataSource();
                      this.showMessage('Card closed successfully');
                    },
                    err => {
                      this.showMessage(err.error.message || err.error || err.message);
                    });
              }
            });
        })
      ];
    }
  }

  generateRenewalCsv() {

  }

  importRenewalCsv() {

  }

  exportCards() {
    const idList = this.table.selection.selected.map(d => d.id);
    this.cardsService
      .export(idList).subscribe(result => {
      FileHelper.saveFile(result);
      this.changeDetectorRefs.detectChanges();
      this.table.refreshTable();
    });
  }

  private loadCompanies() {
    this.companyService.getAll().subscribe(companies => {
      this.companies = companies.data;
      this.onCompanyChange(null);
    });
  }

  onCompanyChange($event: any) {

    if (this.table.filters.companiesFilter.length == 0) {
      this.productsToShow = [];
      return;
    }

    let products = [];

    const companyIds = this.table.filters.companiesFilter.map(value => parseInt(value));
    const futures = [];

    companyIds.forEach(
      value => {
        futures.push(this.productService.getForCompany(value, true));
      }
    );

    forkJoin(
      ...futures,
    ).subscribe(([...pss]) => {

      pss.forEach(ps => products = products.concat(ps));
      this.productsToShow = products;
    });


  }

  private afterExtendCard() {
    this.refreshDataSource();
    this.showMessage('Queued for extension successfully');
    if (this.refreshInterval == null) {
      this.refreshPollCounter = 10;
      this.refreshInterval = setInterval(() => this.refreshPoll(), 5000);
    } else {
this.refreshPollCounter = 10;
}

  }
}
